var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import styled from 'styled-components';
import { Svg } from './Svg';
var MagnifierIcon = function (props) { return (React.createElement(Svg, __assign({}, props),
    React.createElement("g", null,
        React.createElement("path", { d: "M23.4147865,20.5967874 L18.7726377,15.9520956 C21.7010745,11.5660512 20.8266489,5.6726952 16.7510193,2.32701672 C12.6753896,-1.01866175 6.72792579,-0.725384885 3.00084639,3.00505491 C-0.726233006,6.7354947 -1.01724659,12.68632 2.32804078,16.7629992 C5.67332815,20.8396784 11.5637663,21.7124994 15.9463736,18.7809079 L20.5885224,23.4245998 C21.3745869,24.1918001 22.6287221,24.1918001 23.4147865,23.4245998 C24.1950712,22.6436519 24.1950712,21.3777353 23.4147865,20.5967874 Z M10.2588669,3.01195414 C14.2604735,3.01195414 17.5044167,6.25767436 17.5044167,10.2614732 C17.5044167,14.265272 14.2604735,17.5109922 10.2588669,17.5109922 C6.25726021,17.5109922 3.01331707,14.265272 3.01331707,10.2614732 C3.01772333,6.25950192 6.25908677,3.01636282 10.2588669,3.01195414 Z" })))); };
export var Magnifier = styled(MagnifierIcon)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var templateObject_1;
//# sourceMappingURL=Magnifier.js.map